import { native } from '@forest/native-services'

/** Native's identifier for the experiment, used verbatim (GLOSSARY.md). */
const WIN_BACK_EXPERIMENT = 'SubscriptionExpirationWinBackExperiment'

/**
 * The subscription expiration win-back experiment's arm (GLOSSARY.md): Variant
 * offers the promotional annual plan in place of the regular one.
 */
export type WinBackArm = 'Control' | 'Variant'

/**
 * The native experiment group (GLOSSARY.md), used verbatim: only `Variant` is
 * Variant, and any failure to get a group — app < 5.27.0 included — is
 * Control. Never rejects.
 */
export async function loadWinBackArm(): Promise<WinBackArm> {
  try {
    const result = await native.experiment.getGroup({
      experiment: WIN_BACK_EXPERIMENT,
    })
    return result.success && result.data.group === 'Variant'
      ? 'Variant'
      : 'Control'
  } catch {
    return 'Control'
  }
}
